import DepositForm from "./depositForm";
import Kpis from "./kpis";
import RecentEnergyTransactions from "./recentEnergyTransactions";
import RecentTopup from "./recentTopup";
import EnergyRechargeForm from "./EnergyRechargeForm";
import { useEffect, useState } from "react";
import ComponentsBreadcrumb from "src/layout/componentsBreadcrumb";
import { useParams } from "react-router-dom";
import apiCalls from "src/api/apiCalls";

const EnergyDashBoard = () => {
    const { tenantName, tenantId } = useParams();
    const [isTopupGridRefresh, setIsTopupGridRefresh] = useState(false);
    const [isEnergyRechargeGridRefresh, setIsEnergyRechargeGridRefresh] = useState(false);
    const [availableCredit, setAvailableCredit] = useState({ data: 0, loading: true, error: null });
    const [usedCredit, setUsedCredit] = useState({ data: 0, loading: true, error: null });
    const [days, setDays] = useState(1);

    const breadCrumbList = [
        { bname: "Partners", url: "/partners" },
        { bname: tenantName },
        { bname: "Energy" },
    ];

    useEffect(() => {
        availableCreditData();
    }, [isTopupGridRefresh, isEnergyRechargeGridRefresh]);

    useEffect(() => {
        usedCreditData();
    }, [days, isEnergyRechargeGridRefresh]);

    const usedCreditData = async () => {
        setUsedCredit(prev => ({ ...prev, loading: true, error: null }));
        try {
            const response = await apiCalls.getUsedCredits(days, tenantId);
            if (response.ok) {
                setUsedCredit({ data: response.data, loading: false, error: null });
            } else {
                setUsedCredit(prev => ({
                    data: typeof prev.data === 'number' ? prev.data : 0,
                    loading: false,
                    error: apiCalls?.isErrorDispaly(response) || 'Error fetching Used Credit.'
                }));
            }
        } catch (err) {
            setUsedCredit(prev => ({
                data: typeof prev.data === 'number' ? prev.data : 0,
                loading: false,
                error: err.message || 'Error fetching Used Credit.'
            }));
        }
    };

    const availableCreditData = async () => {
        setAvailableCredit(prev => ({ ...prev, loading: true, error: null }));
        try {
            const response = await apiCalls.getAvailableCredits(tenantId);
            if (response.ok) {
                setAvailableCredit({ data: response.data, loading: false, error: null });
            } else {
                setAvailableCredit(prev => ({
                    data: prev.data && typeof prev.data === 'number' ? prev.data : 0,
                    loading: false,
                    error: apiCalls?.isErrorDispaly(response) || 'Error fetching Available Credit.'
                }));
            }
        } catch (err) {
            setAvailableCredit(prev => ({
                data: prev.data && typeof prev.data === 'number' ? prev.data : 0,
                loading: false,
                error: err.message || 'Error fetching Available Credit.'
            }));
        }
    };
    return (
        <div className="container mt-22 account-overview">
            <div className="content-container container">
                <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />

                <div className="row">
                    {/* Left Column: KPI + Energy Recharge */}
                    <div className="col col-lg-7">
                        {/* Row 1: KPIs */}
                        <div className="">
                            <Kpis propsData={{ usedCredit, availableCredit, days, setDays }} />
                        </div>

                        {/* Row 2: Energy Recharge */}
                        <div className="">
                            <EnergyRechargeForm creditData={{ availableCredit, setIsEnergyRechargeGridRefresh }} />
                        </div>
                    </div>

                    {/* Right Column: Deposit Form */}
                    <div className="col col-lg-5">
                        <DepositForm setIsTopupGridRefresh={setIsTopupGridRefresh} />
                    </div>
                </div>

                {/* Bottom Sections */}
                <div className="mt-5">
                    <RecentEnergyTransactions GridRefreshData={{ isEnergyRechargeGridRefresh, setIsEnergyRechargeGridRefresh }} />
                </div>
                <div className="mt-5">
                    <RecentTopup
                        GridRefreshData={{ isTopupGridRefresh, setIsTopupGridRefresh }}
                    />
                </div>
            </div>
        </div>
    );
};

export default EnergyDashBoard;